import { useState } from 'react'
import { apiURL } from '../../utilities/URLs'
import { useNavigate, useSearchParams } from 'react-router-dom'

import ertcLogo from '../../assets/ertcLogo.png'

export default function Login() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const redirect = searchParams.get('redirect') || ''
  const bankingLinkError = searchParams.get('bankingLinkError') || ''

  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [generatingCode, setGeneratingCode] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!email.includes('@') || !email.includes('.')) {
      setError('Please enter a valid email.')
      return
    }

    setGeneratingCode(true)
    const loginResponse = await fetch(`${apiURL}/api/login/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email
      })
    })
    const loginData = await loginResponse.json()
    setGeneratingCode(false)
    if (loginData.response.error) {
      console.error(loginData.response.error)
      setError(loginData.response.error)
    } else {
      const redirectParam = redirect ? `&redirect=${encodeURIComponent(redirect)}` : ''
      navigate(`/verify?email=${encodeURIComponent(email)}${redirectParam}`)
    }
  }

  return (
    <div className='w-screen h-screen flex flex-col items-center justify-center p-6 bg-slate-50 dark:bg-slate-900 transition-colors duration-300'>
      <div className='w-full flex flex-col items-center max-w-sm p-8 bg-white dark:bg-slate-800 shadow-xl dark:shadow-2xl dark:shadow-black/50 rounded-2xl border border-gray-100 dark:border-slate-700/50 dark:border-slate-700 transition-colors duration-300'>
        <img className='w-48 mb-8 drop-shadow-sm' src={ertcLogo} alt='ERTC Logo' />
      <h2 className='text-2xl font-bold mb-6 text-center text-gray-900 dark:text-white transition-colors duration-300'>Login</h2>
      {bankingLinkError && (
        <div className='mb-4 p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-600/30 rounded-lg text-sm text-red-700 dark:text-red-400 text-center'>
          {bankingLinkError}
        </div>
      )}
      <form onSubmit={handleSubmit} className='w-full flex flex-col gap-4'>
          <div className='w-full space-y-1'>
            <label className='text-sm font-medium text-gray-700 dark:text-gray-300 transition-colors duration-300'>Email Address</label>
            <input
              type='email'
              placeholder='Enter your email...'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className='p-3 border border-gray-300 dark:border-slate-600 rounded-lg w-full bg-white dark:bg-slate-800 dark:bg-slate-700/50 text-gray-900 dark:text-white focus:ring-2 focus:ring-ertc-primary focus:border-ertc-primary outline-none transition-all duration-300 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm'
            />
          </div>
          {error && <p className='text-red-500 text-sm text-center font-medium animate-in fade-in'>{error}</p>}
          <button disabled={generatingCode} type='submit' className={`w-full font-semibold transition-all duration-300 py-3 rounded-lg shadow-md active:scale-[0.98] ${generatingCode ? 'bg-gray-400 dark:bg-slate-600 cursor-not-allowed opacity-70' : 'bg-ertc-primary hover:bg-ertc-primary/90 hover:shadow-lg cursor-pointer text-white'}`}>
            Send Login Code
          </button>
          {generatingCode && (
            <div className='flex flex-row items-center justify-center gap-3 mt-4 animate-in fade-in'>
              <div className='animate-spin rounded-full border-4 border-gray-200 dark:border-slate-700 border-t-ertc-primary h-6 w-6'></div>
              <p className='text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors duration-300'>Generating Code...</p>
            </div>
          )}
        </form>
      </div>
    </div>
  )
}